import React, { Component } from "react";
import { connect } from "react-redux";

/*
 * REDUCERS AND TYPES
 */
import { ApplicationMode, ApplicationState } from "../../lib/store/types/ApplicationStateTypes";
import { ActionStates } from "../../lib/rxMode/ActionStates";
import {
  setAppMode,
  setError,
  clearError,
  setLoadingStatus,
  setLoginStatus,
  setIsBetaWorkstation,
  setShouldRedirect,
} from "../../lib/store/reducers/applicationStateReducer";
import {
  startSignalR,
  clearRxAssistingOperator,
  clearRxOperatorInstruction,
  fetchRxSingleItems,
  getRxAssistingOperator,
  hideRxComment,
  pollForRxOrder,
  setCancelRxSortBox,
  setPreviousRxInstruction,
  setRxActionState,
  setRxAssistingOperator,
  setRxBoxModel,
  setRxInputTask,
  setRxMissingAmountDialogSortBoxItem,
  setRxMissingSortBoxItem,
  setRxNormalTransportCart,
  setRxPollForNexSortBoxIntervalID,
  setRxPollForOrderIntervalID,
  setRxShowSingleItemList,
  setRxSingleTransportCart,
  setRxVerifyOperator,
  setRxWeightError,
  sendScannedIPackBoxBarcode,
  sendLoginInfo,
  sendBoxCancellation,
  setCancellaionOrFinishModalStatus,
  setLoopTeamleader,
  setCancellationWithReasonModalStatus,
  setCancelleationReasonMessageShown,
  setFlushQueueModalStatus,
  sendFlushQueueRequest,
  setRxInstructionMessage,
  setSkuPutawayBinShelfNumber,
  setSkuPutawayBoxItem,
  setSkuPutawayErrorMessage,
  perfromSkuPutawayMissingQuantity,
  setRxAutoOrderDone
} from "../../lib/store/reducers/rxBoxModeReducer";
import { setUser, setWorkstation } from "../../lib/store/reducers/loginInfoReducer";
import {
  IWorkstationInfoModel,
  WorkstationInfoModel,
} from "../../lib/interfaces/Login/IWorkstationInfoModel";
import {
  IOperatorInfoModel,
  OperatorInfoModel,
} from "../../lib/interfaces/Login/IOperatorInfoModel";

/*
 * INTERNAL COMPONENT IMPORTS
 */
import Login from "../Login/Login";
import ErrorAlert from "../ErrorAlert/ErrorAlert";
import * as Constants from "./../../utils/Constants";
import {
  getCancellationReason,
  getOperatorMessage,
  sortRXOrderItems,
} from "../../lib/rxMode/UtilMethods";
import SharedFunctions from "../../utils/SharedFunctions";
import BoxItemList from "../BoxItemList/BoxItemList";
import InfoBar from "../InfoBar/InfoBar";
import InfoFooter from "../InfoFooter/InfoFooter";
import SideBarMenu from "../SideBarMenu/SideBarMenu";

/*
 * EXTERNAL LIBS
 */
import { Dimmer, Grid, Loader } from "semantic-ui-react";

/*
 * INTERNAL UTILITY
 */
import * as UtilMethods from "../../utils/UtilMethods";
import { PayloadWrapper } from "../../lib/store/types/PayloadWrapper";
import {
  IRxBoxAppState,
  DispatchType,
  PollForRxOrderType,
  StartSignalR,
  SendOrderInfoRequestType,
} from "../../lib/rxMode/IRxBoxAppState";
import { ILoginInfo, LoginState, LoginStateTypes } from "../../lib/store/types/LoginStateTypes";
import { LayoutHelperState } from "../../lib/store/types/LayoutHelperState";
import { ActionTypes } from "./../../utils/Constants";
import WorkstationEndpoints from "../../lib/workstation/WorkstationEndpoints";
import { IErrorModel } from "../../lib/interfaces/Error/IErrorModel";
import { setCompanyID } from "../../lib/store/reducers/cartReducer";
import { IRxAssistantOperator } from "../../lib/rxMode/IRxAssistantOperator";
import { setRxSingleListButtonHeight } from "../../lib/store/reducers/layoutHelperReducer";
import { IOperatorInstructionModel } from "../../typewriterModels/IOperatorInstructionModel";
import ArticleWeightModal from "../ArticleWeightModal/ArticleWeightModal";
import SkuEndpoints from "../../lib/sku/SkuEndpoints";
import { LimaOperatorTask } from "../../lib/lima/LimaOperatorTask";
import { IPackCancelledWorkstationType } from "../../lib/ipack/IPackCancelledWorkstationType";
import { checkVersion } from "../../utils/versionCheck/versionCheck";
import MissingSkuModal from "../MissingSkuModal/MissingSkuModal";
import MissingSkuModalSelectMissing from "../MissingSkuModal/MissingSkuModalSelectMissing";
import { ISortBoxItemModel } from "../../lib/SortBoxItem/ISortBoxItemModel";
import { ISortBoxModel } from "../../lib/sortbox/ISortBoxModel";
import { LimaWorkstationType } from "../../typewriterModels/WorkstationType";
import { groupBy } from "../../lib/aframeboxlookup/UtilMethods";
import { CancellationReason, IBoxCancellationRequest, IOrderInfo, IPurgeRequest, IRXOperatorInfoModel } from "../../lib/rxAutoMessages/rxAutoMessages";
import WarningModal from "../WarningModal/WarningModal";
import { CancellationModal } from "./cancellationModal/cancellationModal";
import { WarningInputModal } from "../WarningInputModal/WarningInputModal";

const INACTIVITY_TIMEOUT_MINUTES: number = 10;

class RXBoxAppWest extends Component<
  {
    loginState: LoginState;
    layout: LayoutHelperState;
    appState: ApplicationState;
    rxAppState: IRxBoxAppState;
    setLoginStatus: (status: boolean) => void;
    setUser: (user: IOperatorInfoModel | any) => void;
    setAppMode: (applicationMode: ApplicationMode) => void;
    setWorkstation: (workstationInfo: IWorkstationInfoModel) => void;
    setError: (error: IErrorModel) => void;
    pollForRxOrder: () => PollForRxOrderType;
    startSignalR: (workstationID: number) => StartSignalR;
    setIsBetaWorkstation: (enabled: boolean) => void;
    toggleLoading: (enabled: boolean) => void;
    setRxActionState: (actionState: ActionStates) => void;
    setCompanyID: (companyId: number) => void;
    setCancelRxSortBox: () => void;
    setRxVerifyOperator: (enabled: boolean) => void;
    hideRxComment: (orderCommentIndex: number) => void;
    clearError: () => void;
    setRxWeightError: (error: string) => void;
    setShouldRedirect: (shouldRedirect: boolean) => void;
    setRxMissingSortBoxItem: (sortBoxItem: ISortBoxItemModel | null) => void;
    setRxBoxModel: (sortBoxModel: ISortBoxModel) => void;
    fetchRxSingleItems: () => void;
    setRxMissingAmountDialogSortBoxItem: (sortBoxItem: ISortBoxItemModel | null) => void;
    sendScannedIPackBoxBarcode: (iPachBoxBarcode: string) => SendOrderInfoRequestType;
    sendLoginInfo: (loginInfo: IRXOperatorInfoModel) => void;
    sendBoxCancellation: (cancellationRequest: IBoxCancellationRequest) => void;
    setCancellaionOrFinishModalStatus: (status: boolean) => void;
    setLoopTeamleader: (loopTeamLeader: boolean) => void;
    setCancellationWithReasonModalStatus: (status: boolean) => void;
    setCancellationReasonMessageShown: (status: boolean) => void;
    sendFlushQueueRequest: (purgeRequest: IPurgeRequest) => void;
    setFlushQueueModalStatus: (status: boolean) => void;
    setRxInstructionMessage: (message: string | null) => void;
    setSkuPutawayBoxItem:(boxItem: ISortBoxItemModel | null) => void;
    setSkuPutawayBinShelfNumber: (shelfNumber: string) => void;
    setSkuPutawayErrorMessage: (errorMessage:string | null) => void;
    perfromSkuPutawayMissingQuantity: (missingQuantity: number) => void;
    setRxAutoOrderDone: () =>  void;
  },
  {}
> {
  private _versionCheckInterval: NodeJS.Timeout;
  private _inactivityInterval: NodeJS.Timeout;
  private _inputRef: React.RefObject<HTMLInputElement>;
  private _gsCharInputFix: () => void;
  private _handleArticleScanSkuPutaway: (input:string, scanInputType: number,
    boxItems: ISortBoxItemModel[], boxItemsUpdatedCallback: (boxItems:ISortBoxItemModel[]) => void,
     performSkuPutaway: (boxItem:ISortBoxItemModel, input:string) => void , addError:(error:string)=>void, useMissingQuantity: boolean) => void;
  constructor(props: any) {
    super(props);
    this._versionCheckInterval = (undefined as unknown) as NodeJS.Timeout;
    this._inactivityInterval = (undefined as unknown) as NodeJS.Timeout;
    this._inputRef = React.createRef();
    this._gsCharInputFix = UtilMethods.GSCharInputFix.bind(this);
    this._handleArticleScanSkuPutaway =  UtilMethods.HandleArticleScanSkuPutaway.bind(this);
    this._performSkuPutaway = this._performSkuPutaway.bind(this);
  }

  async componentDidUpdate() {
    this._gsCharInputFix();
    if (this.props.rxAppState.inputTask !== LimaOperatorTask.undefined)
      this._inputRef.current?.focus();
  }

  async componentDidMount() {
    const rxAppState: IRxBoxAppState = this.props.rxAppState;
    const loginState: LoginState = this.props.loginState;
    if (!rxAppState.signalRConnectionStatus && loginState.workstationID > 0) {
      this.props.startSignalR(loginState.workstationID);
    }
    this._versionCheckPoll();
    this._inactivtyCheck();
    this._gsCharInputFix();
    if (this.props.rxAppState.inputTask !== LimaOperatorTask.undefined)
      this._inputRef.current?.focus();
  }

  componentWillUnmount() {
    if (this.props.rxAppState.pollForOrderIntervalID != undefined)
      clearInterval(this.props.rxAppState.pollForOrderIntervalID);
    if (this.props.rxAppState.pollForNexSortBoxIntervalID != undefined)
      clearInterval(this.props.rxAppState.pollForNexSortBoxIntervalID);
    if (this._versionCheckInterval != undefined) clearInterval(this._versionCheckInterval);
    if (this._inactivityInterval != undefined) clearInterval(this._inactivityInterval);
  }

  _performSkuPutaway = (boxItem: ISortBoxItemModel, _:string) => {
    this.props.toggleLoading(false);
    this.props.setSkuPutawayBoxItem(boxItem);
  };

  _loginCallback = async (operator: any, loopTeamleader: boolean) => {
    //TODO operator:ILoginInfo
    this.props.clearError();
    await this._setWorkstationID();
    this.props.setAppMode(ApplicationMode.RxBoxMode);
    this.props.setUser(new OperatorInfoModel(operator.operatorId, operator.operatorName));
    this.props.setLoginStatus(true);
    this.props.setLoopTeamleader(loopTeamleader);
    this.props.startSignalR(this.props.loginState.workstationID);
    const loginInfo: IRXOperatorInfoModel = {
      WorkstationID: this.props.loginState.workstationID,
      OperatorID: operator.operatorId,
      LRX: false,
      LoggedIn: true,
      Paused: false,
      LoopTeamleader: loopTeamleader,
    };
    this.props.sendLoginInfo(loginInfo);
  };
  _addError(error: IErrorModel) {
    this.props.setError({
      message: error.message,
      visible: true,
      errorType: -1,
    });
    this.props.toggleLoading(false);
  }
  async _setWorkstationID() {
    return await new Promise<void>((resolve, reject) => {
      let workstationID = UtilMethods.getParamValue("ws");

      var rejectWrap = (e: IErrorModel) => {
        this._addError(e);
        reject();
      };

      WorkstationEndpoints.getWorkstationInformation(workstationID)
        .then((wsResult: any) => {
          var wsType = wsResult.workstationType;
          let isBetaWorkstation = document.location.href.includes("preprod");
          if (
            wsType != Constants.WorkstationTypes.RX &&
            wsType != Constants.WorkstationTypes.RXAuto
          ) {
            this._addError({
              errorType: -1,
              message: "Felaktig arbetsstation!",
              visible: true,
            });
            return;
          }
          this.props.setWorkstation(
            new WorkstationInfoModel(
              workstationID,
              wsType,
              wsResult.branchID,
              wsResult.autoScaleEnabled
            )
          );
          this.props.setIsBetaWorkstation(isBetaWorkstation);
          this.props.setCompanyID(Constants.PackagingTypes.Apotea);
          return resolve();
        })
        .catch(rejectWrap);
    });
  }

  _onInputKeyPress(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key !== "Enter") {
      return;
    }
    let targetRef = e.target as HTMLInputElement;
    let input = targetRef.value.trim().toUpperCase();
    const { orderInfo, sortBoxModel, skuPutawayBoxID } = this.props.rxAppState;
    var boxItems = sortBoxModel?.sortBoxItems?.filter(x=> (x.reservedQuantity - x.verifiedQuantity) > 0  && x.boxID === skuPutawayBoxID);
    if (orderInfo?.SkuPutawayRequired && boxItems != null) {
      let inputType = UtilMethods.ParseInputType(input);
      this._handleArticleScanSkuPutaway(input, inputType, boxItems, (boxItems:ISortBoxItemModel[]) => {
        let reviewBoxUpdated = { ...sortBoxModel, sortBoxItems:boxItems};
        this.props.setRxBoxModel(reviewBoxUpdated as ISortBoxModel);
        this.props.toggleLoading(false);
      } ,this._performSkuPutaway, (error:string)=>{this._addError({
        errorType: -1,
        message:  error,
        visible: true,
      });}, false);
    } else {
        this.props.sendScannedIPackBoxBarcode(input);
    }
    targetRef.value = "";
  }

  _updateBoxItemsState(skuID: number) {
    const { sortBoxModel } = this.props.rxAppState;
    var updateBoxitems = sortBoxModel?.sortBoxItems;
    updateBoxitems?.forEach((bi) => {
      if (bi.skuID === skuID) {
        bi.requireWeighing = false;
      }
    });
  }

  _versionCheckPoll = () => {
    this._versionCheckInterval = setInterval(
      () =>
        checkVersion((shoudRedirect: boolean) => {
          if (shoudRedirect !== this.props.appState.shouldRedirect) {
            this.props.setShouldRedirect(shoudRedirect);
          }
        }),
      20000
    );
  };

  _inactivtyCheck = () => {
    this._inactivityInterval = setInterval(() => {
      const { lastActionTimestamp } = this.props.rxAppState;
      const { loggedIn } = this.props.appState;
      const timeNow = Date.now();
      if (timeNow - lastActionTimestamp > INACTIVITY_TIMEOUT_MINUTES * 60 * 1000 && loggedIn) {
        this.logout();
      }
    }, 10000);
  };

  _setWeightError(message: string) {
    this.props.setRxWeightError(message);
  }
  _setWeightOnSku(skuID: number | null | undefined, weight: number | null | undefined, ref: any) {
    if (skuID && weight) {
      return SkuEndpoints.setWeightOnSku(skuID, weight).then((result: boolean) => {
        if (result == true) {
          this._setWeightError("");
          this._updateBoxItemsState(skuID);
        } else {
          this._setWeightError("Felaktig vikt angiven");
        }
      });
    }
  }

  _measurementCallback = (skuID: number | null | undefined) => {
    if (skuID && skuID !== -1) {
      this._updateBoxItemsState(skuID);
    }
  };

  _sendBoxCancellation = (reason: CancellationReason, comment: string = "", rxBoxIDs: number[] = []) => {
    const { orderInfo }: { orderInfo: IOrderInfo | null } = this.props.rxAppState;
    const { workstationID, operatorID } = this.props.loginState;
    
    const cancellationRequest: IBoxCancellationRequest = {
      CancellationReason: reason,
      Comment: comment,
      SortBoxID: orderInfo !== null ? orderInfo.SortBoxID : -1,
      WorkstationID: workstationID,
      OperatorID: operatorID,
      OrderNumber: orderInfo !== null ? orderInfo.OrderNumber : -1,
      RXBoxIDs: rxBoxIDs,
    };
    this.props.sendBoxCancellation(cancellationRequest);
  };

  onCloseCancellationModalHandler = (cancel: boolean) => {
    this.props.setCancellaionOrFinishModalStatus(false);
    if (cancel) {
      const { orderInfo } = this.props.rxAppState;

      if (orderInfo !== null && orderInfo.SortBoxes.every(sb => sb.Done || sb.Cancelled)) {
        this.props.setRxAutoOrderDone();
        return;
      }

      const cancellationReason = getCancellationReason(orderInfo);
      console.log("cancellationReason", cancellationReason, CancellationReason[cancellationReason]);
      this._sendBoxCancellation(cancellationReason);
    } else {
      console.log("cancelled request");
    }
  };

  onCloseCancellationModalSelectionHandler = (
    cancel: boolean,
    reason: CancellationReason,
    comment: string,
    bags: number[]
  ) => {
    this.props.setCancellationWithReasonModalStatus(false);

    if (cancel) {
      this._sendBoxCancellation(reason, comment, bags);
      console.log(cancel, reason, comment, bags);
    }
  };

  onCloseFlushQueueModalHandler = (cancel: boolean, input: string) => {
    this.props.setFlushQueueModalStatus(false);
    if (!cancel) {
      const { workstationID } = this.props.loginState;
      const req: IPurgeRequest = {
        WorkstationID: workstationID,
        BoxBarcode: input,
      }
      this.props.sendFlushQueueRequest(req);
    }
  };


  _skuIsMissing(skuID: number, shelfNumber: string) {
    var boxItem: ISortBoxItemModel | undefined;
    const { sortBoxModel, orderInfo } = this.props.rxAppState;
    if (orderInfo?.SkuPutawayRequired == true) {
      boxItem =sortBoxModel?.sortBoxItems?.find(
        (bi) => bi.skuID === skuID && bi.shelfNumber === shelfNumber
      );
    } else {
      boxItem = SharedFunctions.mergeItems("skuID", sortBoxModel?.sortBoxItems).find(
        (bi: { skuID: number; shelfNumber: string }) =>
          bi.skuID === skuID && bi.shelfNumber === shelfNumber
      );
    }
    // If the reserved quantity is more than one, ask the user what quantity is missing.
    if (!boxItem) return;
    if (boxItem.reservedQuantity > 1 || orderInfo?.SkuPutawayRequired == true) {
      this.props.setRxMissingAmountDialogSortBoxItem(boxItem);
    } else this.props.setRxMissingSortBoxItem(boxItem);
  }

  logout = () => {
    const loginInfo: IRXOperatorInfoModel = {
      WorkstationID: this.props.loginState.workstationID,
      OperatorID: -1,
      LRX: false,
      LoggedIn: false,
      Paused: false,
      LoopTeamleader: false,
    };
    this.props.sendLoginInfo(loginInfo);
    this.props.setLoginStatus(false);
  };

  render() {
    if (!this.props.loginState.operatorID || this.props.loginState.operatorID === -1) {
      return (
        <React.Fragment>
          <Login
            loginCallback={(operator: ILoginInfo, loopTeamleader: boolean) =>
              this._loginCallback(operator, loopTeamleader)
            }
            workstationID={UtilMethods.getParamValue("ws")}
            loginView={Constants.VIEW.RX}
          />
          <ErrorAlert error={""} />
        </React.Fragment>
      );
    }

    const { loading } = this.props.appState;
    const {
      sortBoxModel,
      rxModeAction,
      crateID,
      sortID,
      rxSortBox,
      nextCartShelf,
      fullCartNumber,
      verifyOperator,
      assistingOperators: assistingOperators,
      rxOrderSku,
      weightError,
      inputTask,
      singleTransportCart,
      normalTransportCart,
      missingSortBoxItem,
      missingAmountDialogSortBoxItem,
      orderInfo,
      stationPaused,
      cancelled,
      maxxMode,
      flushQueueModalOpen,
      loopTeamleader, instructionMessage, 
      skuPutawayBoxID, skuPutawayBoxItem,
      skuPutawayShelfNumber, skuPutawayErrorMessage,
      waitingForEjectBox
    } = this.props.rxAppState;
    const { operatorName, operatorID, autoScaleEnabled, workstationType } = this.props.loginState;
    let boxItems = sortBoxModel === null ? [] : (sortBoxModel.sortBoxItems as ISortBoxItemModel[]);

    const currentSortBoxID = orderInfo?.CurrentSortBoxID;
    const mainSortBoxID = orderInfo?.SortBoxID;
    const orderNumber = orderInfo?.OrderNumber;
    const releaseBox = orderInfo?.ReleaseBox;

    let bagBoxItems: ISortBoxItemModel[][] = Object.values(groupBy(boxItems, "boxID"));

    bagBoxItems = bagBoxItems.map((boxItems) => {
      return SharedFunctions.mergeItems("skuID", boxItems);
    });

    sortRXOrderItems(bagBoxItems, orderInfo, mainSortBoxID, currentSortBoxID);

    boxItems = bagBoxItems.flat();

    let bagClasses = {};

    if (
      sortBoxModel &&
      sortBoxModel !== null &&
      sortBoxModel.sortBoxItems &&
      sortBoxModel.sortBoxItems.length > 0
    ) {
      const boxIDS = sortBoxModel.sortBoxItems
        .filter((i) => i.boxID !== sortBoxModel.sortBoxID)
        .map((i) => i.boxID);
      const uniqueBoxIDs = new Set(boxIDS);
      bagClasses = Array.from(uniqueBoxIDs).reduce((ret, boxID, index) => {
        const i = (index % 4) + 1;
        const bagClass = "rxBagColor" + i;
        return { ...ret, [boxID]: bagClass };
      }, {}) as {};
      bagClasses = { ...bagClasses, [sortBoxModel.sortBoxID]: "rxBagColorNonRX" };
    }

    const rxAuto = this.props.loginState.workstationType === 3;

    const showCancelButton =
      orderInfo && orderInfo.BoxBarcode && orderInfo.BoxBarcode !== "" && !cancelled && !releaseBox && !orderInfo.SkuPutawayRequired && !waitingForEjectBox;

    const completeOrder =
      orderInfo && orderInfo.SortBoxes.length > 0 && orderInfo.SortBoxes.every((sb) => sb.Done);

    const cancellationReason = getCancellationReason(orderInfo);

    const showCancellationMessage = !this.props.rxAppState.cancellationReasonMessageShown //&& this.props.rxAppState.loopTeamleader 
                  && orderInfo && orderInfo.Log && orderInfo.Log.length > 0;

    const boxItemsNonMergedRemaining = sortBoxModel?.sortBoxItems.filter(x=> (x.reservedQuantity - x.verifiedQuantity) > 0 
              && x.boxID !==sortBoxModel?.sortBoxID && x.boxID ===  skuPutawayBoxID)??[];
    return (
      <div className={""}>
        <Dimmer active={loading} inverted>
          <Loader size="big" />
        </Dimmer>
        <SideBarMenu
         logOut={() => this.logout()}
         ></SideBarMenu>
        <Grid columns={2} className="GridContainer">
        <Grid.Column className={orderInfo?.SkuPutawayRequired ? "putawayStock" : "articleColumn"} width={12}>
            {orderInfo?.SkuPutawayRequired ? (
              <div style={{ textAlign: "center" }}>
                <h1>SCANNA TILL LAGERBACK</h1>
              </div>
            ) : null}
            <BoxItemList
              bagClasses={(orderInfo?.SkuPutawayRequired == true ) ? {}: bagClasses }
              boxItems={ (orderInfo?.SkuPutawayRequired == true ) ? boxItemsNonMergedRemaining ?? []: boxItems}
              isLoading={loading}
              skuIsMissingCallback={(
                skuID: number,
                shelfNumber: string
              ) => {
                 this._skuIsMissing(skuID, shelfNumber);
              }}
              skuInputCallback={ orderInfo?.SkuPutawayRequired ? (input:string, scanInputType:number, origin = "") => { 
                this.props.toggleLoading(true);
                this._handleArticleScanSkuPutaway(input, scanInputType,  boxItemsNonMergedRemaining, (boxItems:ISortBoxItemModel[]) => {
                  let reviewBoxUpdated = { ...sortBoxModel, sortBoxItems:boxItems};
                  this.props.setRxBoxModel(reviewBoxUpdated as ISortBoxModel);
                  this.props.toggleLoading(false);
                } ,this._performSkuPutaway, (error:string)=>{this._addError({
                  errorType: -1,
                  message:  error,
                  visible: true,
                });}, false);
              }: {}}
              isSingle={undefined}
              isWaitingForBox={undefined}
              aframe={undefined}
              skuChannels={undefined}
              isPaused={undefined}
              isAuto={undefined}
              isUrgent={undefined}
              showProgress={orderInfo?.SkuPutawayRequired}
              isRxMode={true}
              currentRXSortBoxID={orderInfo?.SkuPutawayRequired ? skuPutawayBoxID?? -1: orderInfo?.CurrentSortBoxID}
              allSortBoxItems={(orderInfo?.SkuPutawayRequired == true ) ?
                boxItemsNonMergedRemaining : boxItems}
            ></BoxItemList>
          </Grid.Column>
          <Grid.Column className="flexColumn" width={4}>
            <InfoBar
              fromReview={false}
              latestShipping={null}
              noPackMessage={false}
              allVerified={false}
              currentCart={crateID}
              isAuto={false}
              nextAction={ActionTypes.SCAN_ARTICLE}
              shelfCallback={() => this.props.setCancelRxSortBox()}
              cancelSortBoxAccess={false}
              showCancelButton={true}
              waitingForDeliveryRequest={false}
              waitingForNewIPackBox={false}
              operatorInstruction={(waitingForEjectBox && (orderInfo?.SkuPutawayRequired == false || cancelled)) ? "TRYCK PÅ KNAPPEN" : getOperatorMessage(
                rxModeAction,
                sortBoxModel,
                nextCartShelf,
                orderInfo,
                cancelled
              )}
              operator={operatorName}
              operatorID={operatorID}
              isPartialDelivery={false}
              wasCancelled={
                sortBoxModel &&
                sortBoxModel.forceNormalWorkstation == IPackCancelledWorkstationType.Manual &&
                rxModeAction === ActionStates.COMPLETE_BOX
              }
              cartContent={null}
              currentOrderNumber={orderNumber}
              currentSortBoxID={rxSortBox}
              currentShelf={sortBoxModel?.shelfNumber}
              cartType={null}
              shippingMethod={null}
              weight={0}
              scannedWeight={null}
              fromAFrameControl={false}
              sortID={sortID}
              aFrameCompletionMode={false}
              isPaused={true}
              isSingle={false}
              sortType={sortBoxModel?.sortType}
              workstationType={this.props.loginState.workstationType}
              sortWorkstationType={null}
              isScanIdValidationCancelSortboxRequired={
                this.props.appState.isScanIdValidationCancelSortboxRequired
              }
              aFrameControlStation={false}
              rxMode={!(orderInfo?.SkuPutawayRequired === true)}
              rxAuto={rxAuto}
              stationPaused={stationPaused}
              verifyOperatorExternal={verifyOperator}
              setVerifyOperatorCallback={this.props.setRxVerifyOperator}
              nextCartShelf={nextCartShelf}
              rxAssistantOperators={assistingOperators}
              shippingHasIDCheck={sortBoxModel?.shippingMethodHasIDCheck}
              rxOrderSku={rxOrderSku}
              rxCheckSubsidy={
                sortBoxModel &&
                sortBoxModel.forceNormalWorkstation == IPackCancelledWorkstationType.Paused
              }
              orderInfo={orderInfo}
              cancelRXAutoOrder={
                rxAuto && cancellationReason === CancellationReason.RxOrderIncomplete
                  ? () => this.props.setCancellationWithReasonModalStatus(true)
                  : rxAuto
                  ? () => this.props.setCancellaionOrFinishModalStatus(true)
                  : null
              }
              cancelled={cancelled}
              rxAutoShowCancel={showCancelButton}
              maxxMode={maxxMode}
              loopTeamleader={loopTeamleader}
              prefillBags={boxItems.filter((bi) => bi.skuID > 70000000).length}
            ></InfoBar>
          </Grid.Column>
        </Grid>
        {!!missingSortBoxItem ? (
          <MissingSkuModal
            open={!!missingSortBoxItem}
            fromReview={false}
            removeSkuAccess={false}
            currentOrderNumber={orderNumber}
            boxItem={missingSortBoxItem}
            foundSkuCallback={(newSortBoxItems: ISortBoxItemModel[]) => {
              if (rxSortBox === newSortBoxItems[0].boxID) {
                newSortBoxItems = SharedFunctions.getUpdatedBoxItems(
                  newSortBoxItems,
                  sortBoxModel?.sortBoxItems
                );
                const newSortBoxModel = { ...sortBoxModel, sortBoxItems: newSortBoxItems };
                this.props.setRxBoxModel(newSortBoxModel as ISortBoxModel);
              } else {
                this.props.fetchRxSingleItems();
              }
            }}
            onClose={() => {
              this.props.setRxMissingSortBoxItem(null);
            }}
            cartNumber={null}
            isScanIdValidationRemoveSkuRequired={
              this.props.appState.isScanIdValidationRemoveSkuRequired
            }
            partialDelivery={false}
            loginState={this.props.loginState}
            rxWest={true}
          />
        ) : null}
        {!!missingAmountDialogSortBoxItem ? (
          <MissingSkuModalSelectMissing
            onCloseClearState={() => {
              this.props.setRxMissingAmountDialogSortBoxItem(null);
            }}
            boxItem={missingAmountDialogSortBoxItem}
            missingSkuSetVerifiedQuantity={(
              missingAmount: number | null,
              boxItem: ISortBoxItemModel
            ) => {
              if (!missingAmount) return;
              if (orderInfo?.SkuPutawayRequired == true && sortBoxModel) {
                boxItem.missingQuantity = missingAmount;
                this.props.setSkuPutawayBinShelfNumber("");
                this._performSkuPutaway(boxItem,"");
                this.props.perfromSkuPutawayMissingQuantity(missingAmount);
            } else{
              boxItem.verifiedQuantity = boxItem.reservedQuantity - missingAmount;
              this.props.setRxMissingAmountDialogSortBoxItem(null);
              this.props.setRxMissingSortBoxItem(boxItem);
            }} }
            reservedQuantityIsMaxMissing={false}
          />
        ) : null}
        <ErrorAlert error={this.props.appState.errorMessage} />
        {this.props.rxAppState.cancellationOrFinishBoxModalOpen ? (
          <WarningModal
            open={true}
            onClose={(choice: boolean) => this.onCloseCancellationModalHandler(choice)}
            message={`Vill du ${
              showCancelButton && !completeOrder ? "avbryta" : "klarmarkera"
            } order?`}
            header={`${showCancelButton && !completeOrder ? "Avbryt" : "Klarmarkera"} order`}
            cssClass={""}
            autoClose={false}
            isCartInstruction={false}
            workstationID={this.props.loginState.workstationID}
            closeButtonText={"JA"}
            cancelButtonText={"NEJ"}
          ></WarningModal>
        ) : null}
        {showCancellationMessage ? (
          <WarningModal
            open={true}
            onClose={() => this.props.setCancellationReasonMessageShown(true)}
            message={orderInfo.Log[0].Message}
            header={`Avbruten av ${orderInfo.Log[0].User}`}
            cssClass={""}
            autoClose={false}
            isCartInstruction={false}
            workstationID={this.props.loginState.workstationID}
            closeButtonText={"OK"}
            ></WarningModal>
        ) : null}
        {flushQueueModalOpen ? (
          <WarningInputModal
            open={true}
            onClose={(cancel: boolean, comment: string) => this.onCloseFlushQueueModalHandler(cancel, comment)}
            header={"Scanna första lådan!"}
            needConfirmation={true}
          ></WarningInputModal>
        ) : null}
        {orderInfo?.SkuPutawayRequired && skuPutawayBoxItem && !skuPutawayShelfNumber && !missingAmountDialogSortBoxItem ? (
          <WarningInputModal
            open={true}
            placeholder={"hyllplats"}
            onClose={(cancel: boolean, input: string) => { 
              if (cancel) this.props.setSkuPutawayBoxItem(null);
              else{
                UtilMethods.ValidateShelf(input).then( (result:string) => {
                  this.props.setSkuPutawayBinShelfNumber(result);
                }).catch((error : string) => {
                  this.props.setSkuPutawayErrorMessage(error);
                });       
              }
             }}
            header={"Scanna hyllplats för "+ skuPutawayBoxItem.name}
            needConfirmation={false}
            validateLength={7}
            errorMessage={skuPutawayErrorMessage}
          ></WarningInputModal>
        ) : null}
        {instructionMessage ? (
                    <WarningModal
                    open={true}
                    cssClass={"warning-modal-instruction"}
                    autoClose={false}
                    header="Avbruten"
                    message={instructionMessage}
                    onClose={() => {
                      this.props.setRxInstructionMessage(null)
                    }}
                  ></WarningModal>
        ) : null}
        {this.props.rxAppState.cancellationWithReasonModalOpen ? (
          <CancellationModal
            open={true}
            onClose={this.onCloseCancellationModalSelectionHandler}
            loopTeamleader={loopTeamleader}
            orderInfo={orderInfo}
          ></CancellationModal>
        ) : null}
        <ArticleWeightModal
          scannedSKU={
            sortBoxModel?.sortBoxItems?.find(
              (z) => z.requireWeighing && z.boxID !== orderInfo?.SortBoxID
            )?.skuID ?? -1
          }
          boxItems={sortBoxModel?.sortBoxItems}
          getWeight={(skuID: number | null | undefined) =>
            skuID ? SkuEndpoints.getWeightSku(skuID) : null
          }
          setWeight={(skuID: number | null | undefined, weight: number | null | undefined) => {
            return this._setWeightOnSku(skuID, weight, this);
          }}
          autoScaleEnabled={autoScaleEnabled}
          cartShelfID={sortBoxModel?.shelfNumber?.toString() ?? ""}
          callback={this._measurementCallback}
          weightError={weightError}
        />
        <InfoFooter
          operatorName={operatorName}
          isApoteaPackaging={true}
          sortID={sortID}
          cartID={fullCartNumber}
          orderNumber={rxModeAction === ActionStates.COMPLETE_BOX ? orderNumber : null}
          cartShelf={undefined}
          workstationID={this.props.loginState.workstationID}
          companyID={undefined}
          pendingInstruction={undefined}
          boxID={undefined}
          cartLocationHistory={undefined}
          singleTransportCart={singleTransportCart ? singleTransportCart : ""}
          normalTransportCart={normalTransportCart ? normalTransportCart : ""}
          rxSignalRConnectionStatus={this.props.rxAppState.signalRConnectionStatus}
          rxAuto={rxAuto}
        />
        <input
          placeholder={
            inputTask === LimaOperatorTask.RegisterSingleTransportCart
              ? "Singeltransportback"
              : inputTask === LimaOperatorTask.RegisterNormalTransportCart
              ? "Normal transportback"
              : ""
          }
          className="ScanInputField"
          autoComplete="off"
          id="ScanInputField"
          autoFocus
          onKeyDown={(e) => this._onInputKeyPress(e)}
          ref={this._inputRef}
          disabled={
            inputTask !== LimaOperatorTask.RegisterSingleTransportCart &&
            inputTask !== LimaOperatorTask.RegisterNormalTransportCart &&
            workstationType !== LimaWorkstationType.RXAuto &&
            workstationType !== LimaWorkstationType.RXAuto
          }
        />
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    loginState: state.loginInfoReducer as LoginState,
    layout: state.layoutHelperReducer as LayoutHelperState,
    appState: state.applicationStateReducer as ApplicationState,
    rxAppState: state.rxModeReducer as IRxBoxAppState,
  };
};

const mapDispatchToProps = (dispatch: DispatchType) => {
  return {
    setLoopTeamleader: (teamleader: boolean) =>
      dispatch(setLoopTeamleader(new PayloadWrapper(teamleader))),
    sendBoxCancellation: (cancellationRequest: IBoxCancellationRequest) =>
      dispatch(sendBoxCancellation(cancellationRequest)),
    sendLoginInfo: (loginInfo: IRXOperatorInfoModel) => dispatch(sendLoginInfo(loginInfo)),
    startSignalR: (workstationID: number) =>
      dispatch(startSignalR(new PayloadWrapper(workstationID))),
    setAppMode: (mode: ApplicationMode) => dispatch(setAppMode(new PayloadWrapper(mode))),
    toggleLoading: (loading: boolean) => dispatch(setLoadingStatus(new PayloadWrapper(loading))),
    clearError: () => dispatch(clearError()),
    setWorkstation: (workstationInfo: IWorkstationInfoModel) =>
      dispatch(setWorkstation(workstationInfo)),
    setUser: (user: IOperatorInfoModel) => dispatch(setUser(user)),
    setError: (error: IErrorModel) => dispatch(setError(error)),
    pollForRxOrder: () => dispatch(pollForRxOrder()),
    setLoginStatus: (status: boolean) => dispatch(setLoginStatus(new PayloadWrapper(status))),
    setIsBetaWorkstation: (beta: boolean) =>
      dispatch(setIsBetaWorkstation(new PayloadWrapper(beta))),
    setRxActionState: (actionState: ActionStates) =>
      dispatch(setRxActionState(new PayloadWrapper(actionState))),
    setCompanyID: (companyID: number) => dispatch(setCompanyID(new PayloadWrapper(companyID))),
    setCancelRxSortBox: () => dispatch(setCancelRxSortBox()),
    setRxVerifyOperator: (enabled: boolean) =>
      dispatch(setRxVerifyOperator(new PayloadWrapper(enabled))),
    hideRxComment: (orderCommentIndex: number) =>
      dispatch(hideRxComment(new PayloadWrapper(orderCommentIndex))),
    setRxPollForNexSortBoxIntervalID: (intervalId: NodeJS.Timeout) =>
      dispatch(setRxPollForNexSortBoxIntervalID(new PayloadWrapper(intervalId))),
    setRxPollForOrderIntervalID: (intervalId: NodeJS.Timeout) =>
      dispatch(setRxPollForOrderIntervalID(new PayloadWrapper(intervalId))),
    setRxAssistingOperator: (operator: IRxAssistantOperator) =>
      dispatch(setRxAssistingOperator(operator)),
    clearRxAssistingOperator: (assistingOperatorID: number) =>
      dispatch(clearRxAssistingOperator(new PayloadWrapper(assistingOperatorID))),
    getRxAssistingOperator: () => dispatch(getRxAssistingOperator()),
    setRxShowSingleItemList: (visiblity: boolean) =>
      dispatch(setRxShowSingleItemList(new PayloadWrapper(visiblity))),
    setRxSingleListButtonHeight: (height: number) =>
      dispatch(setRxSingleListButtonHeight(new PayloadWrapper(height))),
    setPreviousRxInstruction: (instruction: IOperatorInstructionModel) =>
      dispatch(setPreviousRxInstruction(instruction)),
    setRxWeightError: (error: string) => dispatch(setRxWeightError(new PayloadWrapper(error))),
    setRxInputTask: (operatorTask: LimaOperatorTask) =>
      dispatch(setRxInputTask(new PayloadWrapper(operatorTask))),
    setRxSingleTransportCart: (transportCart: string) =>
      dispatch(setRxSingleTransportCart(new PayloadWrapper(transportCart))),
    sendScannedIPackBoxBarcode: (iPackBoxBarcode: string) =>
      dispatch(sendScannedIPackBoxBarcode(new PayloadWrapper(iPackBoxBarcode))),
    setRxNormalTransportCart: (transportCart: string) =>
      dispatch(setRxNormalTransportCart(new PayloadWrapper(transportCart))),
    clearRxOperatorInstruction: () => dispatch(clearRxOperatorInstruction()),
    setShouldRedirect: (shouldRedirect: boolean) =>
      dispatch(setShouldRedirect(new PayloadWrapper(shouldRedirect))),
    setRxMissingSortBoxItem: (sortBoxItem: ISortBoxItemModel | null) =>
      dispatch(setRxMissingSortBoxItem(new PayloadWrapper(sortBoxItem))),
    setRxBoxModel: (sortBoxModel: ISortBoxModel) =>
      dispatch(setRxBoxModel(new PayloadWrapper(sortBoxModel))),
    fetchRxSingleItems: () => dispatch(fetchRxSingleItems()),
    setRxMissingAmountDialogSortBoxItem: (sortBoxItem: ISortBoxItemModel | null) =>
      dispatch(setRxMissingAmountDialogSortBoxItem(new PayloadWrapper(sortBoxItem))),
    setCancellaionOrFinishModalStatus: (toggle: boolean) =>
      dispatch(setCancellaionOrFinishModalStatus(new PayloadWrapper(toggle))),
    setCancellationWithReasonModalStatus: (toggle: boolean) =>
      dispatch(setCancellationWithReasonModalStatus(new PayloadWrapper(toggle))),
    setCancellationReasonMessageShown: (toggle: boolean) => dispatch(setCancelleationReasonMessageShown(new PayloadWrapper(toggle))),
    setFlushQueueModalStatus: (toggle: boolean) => dispatch(setFlushQueueModalStatus(new PayloadWrapper(toggle))), 
    sendFlushQueueRequest: (request: IPurgeRequest) => dispatch(sendFlushQueueRequest(request)),
    setRxInstructionMessage: (message: string | null) => dispatch(setRxInstructionMessage(new PayloadWrapper(message))),
    setSkuPutawayBoxItem: (skuID: ISortBoxItemModel | null) => dispatch(setSkuPutawayBoxItem(new PayloadWrapper(skuID))),
    setSkuPutawayBinShelfNumber: (shelfNumber: string | null) => dispatch(setSkuPutawayBinShelfNumber(new PayloadWrapper(shelfNumber))),
    setSkuPutawayErrorMessage: (shelfNumber: string | null) => dispatch(setSkuPutawayErrorMessage(new PayloadWrapper(shelfNumber))),
    perfromSkuPutawayMissingQuantity: (missingQuantity: number) => dispatch(perfromSkuPutawayMissingQuantity(new PayloadWrapper(missingQuantity))),
    setRxAutoOrderDone: () => dispatch(setRxAutoOrderDone()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RXBoxAppWest);
